module.exports = __webpack_public_path__ + "img/logo.4c84b29a.png";